/**
 * Template types for initialization.
*/
export enum TemplateTypes {
    Wrapper = 1, // template to be rendered around grid
    Content = 2, // grid content
    Tab = 3, // tab in form
    Group = 4, // group in form
    Columns = 5, // columns in form
    Column  = 6 // single column in form
    //Control = 6 // control in form
}
